import React, { FC } from 'react';
import { Circle } from 'react-leaflet';
import { LatLng } from 'leaflet';

interface HighlightHaloProps {
  position: LatLng;
}

export const HighlightHalo: FC<HighlightHaloProps> = React.memo(({ position }) => (
  <>
    <Circle
      center={position}
      radius={5}
      pathOptions={{
        color: '#FFD700',
        weight: 2,
        fillOpacity: 0.2,
        opacity: 0.4,
        className: 'animate-pulse'
      }}
    />
    <Circle
      center={position}
      radius={3}
      pathOptions={{
        color: '#FFD700',
        weight: 2,
        fillOpacity: 0.3,
        opacity: 0.6,
        className: 'animate-pulse'
      }}
    />
  </>
));
